import './Markers.css';

export function PersonSvgData(width: number, height: number, fillColor: string) {
  return `
    <svg class="idata-target-marker" xmlns="http://www.w3.org/2000/svg" width="${width}" height="${height}" viewBox="0 0 2280 2280">
   <g fill=${fillColor} style="transform: none;">
      <g>
         <path id="pr35WwdBi" d="M150 2112 c0 -34 30 -117 53 -144 40 -48 123 -103 279 -183 134 -69 162 -88 229 -154 163 -163 171 -291 26 -433 -78 -77 -101 -122 -117 -232 -13 -89 -8 -133 20 -169 18 -23 20 -40 19 -169 -1 -80 4 -161 10 -185 16 -59 70 -134 114 -159 34 -19 36 -22 18 -27 -13 -3 -21 -13 -21 -27 0 -20 4 -21 38 -15 35 6 38 4 49 -25 15 -40 49 -40 45 0 0 3 -4 13 -8 24 -6 16 -2 16 37 -7 86 -50 242 -58 371 -21 136 40 255 140 292 244 16 45 19 78 17 196 -1 137 0 144 24 180 29 42 31 74 11 185 -18 97 -43 144 -107 198 -69 59 -114 151 -107 220 7 75 44 139 127 221 65 64 96 85 211 144 168 85 259 145 295 192 27 35 55 109 55 146 0 17 -35 18 -990 18 -950 0 -990 -1 -990 -18z"></path>
      </g>
   </g>
</svg>`;
}
